import React from 'react';
import styled from 'styled-components';

import { CARD_TYPES, CARD_WRAPPER_TYPES } from '../../../shared/constants';
import { ICard } from '../../../types/shared';

import { ChevronRight } from '../../atoms/icons/ChevronRight';
import Link from '../../atoms/link/Link';

import { DEQ_TYPES } from '../../../utils/deq';
import { getCtaLink } from '../../../utils/generic';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { Body } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

interface Props {
  linkTiles: ICard[];
}

const LinkTilesWrapper = ({ linkTiles }: Props) => (
  <section id={CARD_WRAPPER_TYPES.linkTilesWrapper}>
    {linkTiles.map((link, index: number) => {
      return (
        <LinkBanner
          key={index}
          href={
            (link.primaryLink && (getCtaLink(link.primaryLink) as string)) ||
            '/404/'
          }
          trackingType={DEQ_TYPES.btnLink}
          trackingComponent={CARD_TYPES.linkTile}
          trackingLabel={link.title}
        >
          <LinkInner>
            <Body>{link.title}</Body>
            <ChevronRight />
          </LinkInner>
        </LinkBanner>
      );
    })}
  </section>
);

export default LinkTilesWrapper;

const LinkBanner = styled(Link)`
  background-color: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  color: ${({ theme }) => theme.colors.abnGreen300};
  display: block;
  margin-bottom: 1px;
  padding: ${Spacings.S} ${Spacings.L};

  svg {
    transition: transform 0.1s ease;
    flex-shrink: 0;
  }

  ${mq.from.breakpoint.L`
    &:hover {
      background-color: ${Colors.abnGreen50};
      & svg {
        transform: translateX(3px);
      }
    }
  `}

  &:active {
    background-color: ${Colors.abnGreen55};
    box-shadow: none;
  }
`;

const LinkInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
